import { Tooltip } from '@flywire/headlessui-tailwindcss';
import { Currency } from 'models/currency';
import { useTranslations } from 'utils/translations/useTranslations';

function LabelWithTooltip({
  value,
  currency,
}: { value: string; currency: Currency }) {
  const i18n = useTranslations();
  return (
    <div className="mb-4" data-testid="offer-rewards-eligible">
      <div className="flex justify-end whitespace-nowrap">
        <Tooltip position="bottom">
          <Tooltip.Trigger
            className="bg-transparent"
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div className="inline-flex shadow-lg">
              <span className="bg-yellow-400 text-blue-800 px-1 py-1 rounded-l text-xs font-semibold">
                {currency.symbol}
              </span>
              <span className="bg-gradient-to-r from-blue-800 to-blue-600 text-white px-4 py-1 uppercase underline decoration-yellow-400 decoration-dotted decoration-2 underline-offset-4 text-xs font-semibold">
                {value}
              </span>
            </div>
          </Tooltip.Trigger>
          <Tooltip.Content>
            <div className="w-52 text-sm text-center whitespace-normal break-words">
              {i18n.t('paymentOptions.redeemRewards.tooltip')}
            </div>
          </Tooltip.Content>
        </Tooltip>
      </div>
    </div>
  );
}

LabelWithTooltip.displayName = 'LabelWithTooltip';

export { LabelWithTooltip };
